import React from 'react';
import MiniExtendedHoursTable from './MiniExtendedHoursTable';

const MiniExtendedHoursGainers = ({ marketSession, data }) => {
    const sessionName = marketSession === 'pre' ? 'Pre-Market' : 'After-Market';

    return (
        <MiniExtendedHoursTable
            type="gainers"
            marketSession={marketSession}
            title={`${sessionName} Gainers`}
            linkTo={`/market-movers?tab=${marketSession}-market&${marketSession}market=gainers`}
            data={data}
        />
    );
};

export default MiniExtendedHoursGainers;